<template>
  <div class="form-group">
    <label class="form-label">Событие*</label>
    <CustomSelect name="event" @initialize="onInitialize" @itemSelected="onItemSelected">
      <option data-component="Empty" value="LivingUntilTheAnniversary">Дожитие до годовщины срока страхования</option>
      <option data-component="Empty" value="Survival">Дожитие до окончания срока страхования</option>
      <option data-component="DeathSelectWithDescription" value="LeavingLife">Уход из жизни</option>
    </CustomSelect>
  </div>

  <component :is="barrierComponent"></component>

  <ContractInfoInsurer/>
</template>

<script>
import ContractInfoInsurer from "@/components/insurances/shared/ContractInfoInsurer";
import DeathSelectWithDescription from "@/components/insurances/Barrier/childs/DeathSelectWithDescription";
import * as mns from "@/store/mutation-types";
import {mapGetters} from "vuex";
import Empty from "@/components/utils/Empty";
import CustomSelect from "@/components/utils/CustomSelect";

export default {
  anotherNameLife: "Barrier",
  components: {
    Empty, ContractInfoInsurer, CustomSelect, DeathSelectWithDescription
  },
  methods: {
    onInitialize(event){
      this.$store.commit(mns.SET_BARRIER_VALUE, event.getValue().value);
      this.$store.commit(mns.SET_BARRIER_COMPONENT, event.getValue().customProperties.component);
    },
    onItemSelected(event){
      const choice = event.detail.choice;

      this.$store.commit(mns.SET_BARRIER_VALUE, choice.value);
      this.$store.commit(mns.SET_BARRIER_COMPONENT, choice.customProperties.component);
    },
  },
  computed: {
    ...mapGetters(['barrierComponent', ]),
  }
}
</script>

<style scoped>

</style>